export default "__VITE_ASSET__1Hi75Bd$__"